import { Button, makeStyles } from "@fluentui/react-components";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    link: {
        textDecoration: "none"
    },
    button: {
        textAlign: "left",
        justifyContent: "flex-start",
        margin: "0",
        height: "30px",
        display: "flex",
        alignItems: "center",
    }
});

interface IMainMobileLink {
    path: string;
    text: string;
    onNavigate: () => void;
}

const MobileMainLink = (props: IMainMobileLink) => {
    const { path, text } = props;
    const styles = useStyles();

    return (
        <Link to={path} className={styles.link} onClick={props.onNavigate}>
            <Button as="a" appearance="subtle" className={styles.button}>
                {text}
            </Button>
        </Link>
    );
};

export default MobileMainLink;